import { render } from "./FeedComponent.vue?vue&type=template&id=3056424c&scoped=true&ts=true"
import script from "./FeedComponent.vue?vue&type=script&lang=ts"
export * from "./FeedComponent.vue?vue&type=script&lang=ts"

import "./FeedComponent.vue?vue&type=style&index=0&id=3056424c&lang=sass&scoped=true"
/* custom blocks */
import block0 from "./FeedComponent.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3056424c"]])

export default __exports__